import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
import Axios from 'axios';

// Pages

import Users from '@/components/views/Users/index';
import User from '@/components/views/Users/single';
import Clients from '@/components/views/Clients/index';
import Client from '@/components/views/Clients/single';
import ClientCenters from '@/components/views/Clients/centers';
import Channels from '@/components/views/Channels/index';
import IssueCategories from '@/components/views/IssueCategories/index';
import Brands from '@/components/views/Brands/index';
import Sectors from '@/components/views/Sectors/index';
import Products from '@/components/views/Products/index';
import Places from '@/components/views/Places/index';
import Clusters from '@/components/views/Clusters/index';
import Cluster from '@/components/views/Clusters/single';
import Issues from '@/components/views/Issues/index';
import Tasks from '@/components/views/Tasks/index';
import Campaigns from '@/components/views/Campaigns/index';
import Campaign from '@/components/views/Campaigns/single';
import CampaignOptions from '@/components/views/Campaigns/options';
import CampaignLinks from '@/components/views/Campaigns/links';
import Chat from '@/components/views/Chat/index';
import Stats from '@/components/views/Stats/index';
import Stock from '@/components/views/Stock/index';
import Holidays from '@/components/views/Holidays/index';
import Info from '@/components/views/Info/index';
import Kpi from '@/components/views/Kpi/index';
import KpiCenters from '@/components/views/Kpi/centers';
import Payroll from '@/components/views/Payroll/index';
import ActivityReport from '@/components/views/ActivityReport/index';
import Incentives from '@/components/views/Incentives/index';
import Expenses from '@/components/views/Expenses/index';
import UserLogs from '@/components/views/UserLogs/index';
import VersionLogs from '@/components/views/VersionLogs/index';
import Integrations from '@/components/views/Integrations/index';


// Campaign Modules

import Centers from '@/components/views/modules/Centers';
import Reports from '@/components/views/modules/Reports/index';
import Report from '@/components/views/modules/Reports/single';
import Pictures from '@/components/views/modules/Pictures/index';
import Calendar from '@/components/views/modules/Calendar/index';
import Geolocation from '@/components/views/modules/Geolocation/index';
import CampaignIssueCategories from '@/components/views/modules/CampaignIssueCategories/index';
import DayTasks from '@/components/views/modules/DayTasks/index';
import DayTask from '@/components/views/modules/DayTasks/single';
import Workers from '@/components/views/modules/Workers/index';
import Worker from '@/components/views/modules/Workers/single';
import Files from '@/components/views/modules/Files/index';
import Evaluation from '@/components/views/modules/Evaluations/index';

// Others

import Login from '@/components/views/Login';
import { RouteTag } from '@/utils/constants';

Vue.use( Router );

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/', name: 'Admin', redirect: '/stats' },
    { path: '/login', name: 'Login', component: Login },
    { path: '/stats', name: 'Estadísicas', component: Stats, meta: { menu: 'main', icon: '$stats', roles: [99, 1, 2, 3, 4, 101], tag: RouteTag.STATS }},
    { path: '/campaigns', name: 'Campañas', component: Campaigns, meta: { menu: 'main', icon: '$campaigns', roles: [99, 1, 2, 3, 4, 101] } },
    { path: '/campaigns/:id', name: 'Campaña', component: Campaign },
    { path: '/campaigns/:id/options', name: 'Opciones de campaña', component: CampaignOptions },
    { path: '/campaigns/:id/links', name: 'Links', component: CampaignLinks },
    { path: '/campaigns/:id/centers', component: Centers },
    { path: '/campaigns/:id/centers/:index', redirect: to => `/campaigns/${to.params.id}/centers` },
    { path: '/campaigns/:id/centers/:index/targets', component: KpiCenters },
    { path: '/campaigns/:id/workers', component: Workers },
    { path: '/campaigns/:id/workers/:index', component: Worker },
    { path: '/campaigns/:id/day-tasks', component: DayTasks },
    { path: '/campaigns/:id/day-tasks/:index', component: DayTask },
    { path: '/campaigns/:id/reports', component: Reports },
    { path: '/campaigns/:id/reports/:index', component: Report },
    { path: '/campaigns/:id/pictures', component: Pictures },
    { path: '/campaigns/:id/calendar', component: Calendar },
    { path: '/campaigns/:id/location', component: Geolocation },
    { path: '/campaigns/:id/issue-categories', component: CampaignIssueCategories },
    { path: '/campaigns/:id/files', component: Files },
    { path: '/campaigns/:id/evaluations', component: Evaluation },
    { path: '/campaigns/:id/targets', component: Kpi },
    { path: '/campaigns/:id/targets/centers', component: KpiCenters },
    { path: '/workers', name: 'Fichajes', component: Workers, meta: { menu: 'main', icon: '$worker', roles: [99, 1, 2, 3, 101], tag: RouteTag.WORKERS }},
    { path: '/workers/:id', name: 'Fichaje', component: Worker },
    { path: '/day-tasks', name: 'Registros', component: DayTasks, meta: { menu: 'main', icon: '$register', roles: [99, 1, 2, 3, 101], tag: RouteTag.TASKS } },
    { path: '/day-tasks/:id', component: DayTask },
    { path: '/location', name: 'Localizaciones', component: Geolocation, meta: { menu: 'main', icon: '$place', roles: [3], tag: RouteTag.GEOLOCATION }},
    { path: '/payroll', name: 'Nómina', component: Payroll,  meta: { menu: 'main', icon: '$money', roles: [101]}},
    { path: '/activity-report', name: 'Informe de actividad', component: ActivityReport, meta: { menu: 'main', icon: '$stats', roles: [101]}},
    { path: '/incentives', name: 'Incentivos', component: Incentives, meta: { menu: 'main', icon: '$money', roles: [101]}},
    { path: '/expenses', name: 'Gastos', component: Expenses, meta: { menu: 'main', icon: '$money', roles: [101]}},
    { path: '/evaluations', name: 'Evaluaciones', component: Evaluation,  meta: { menu: 'main', icon: 'mdi-check', roles: [99, 1, 2, 4, 101]}},
    { path: '/pictures', name: 'Fotografías', component: Pictures, meta: { menu: 'main', icon: '$camera', roles: [99, 1, 2, 3, 101], tag: RouteTag.PICTURES } },
    { path: '/users', name: 'Usuarios', component: Users, meta: { menu: 'main', icon: '$user', roles: [99, 1, 2, 4, 101], tag: 3 } },
    { path: '/users/:id', name: 'Usuario', component: User },
    { path: '/users/:id/evaluation', name: 'Evaluación del usuario', component: Evaluation },
    { path: '/stock', name: 'Informe Ventas', component: Stock, meta: { menu: 'main', icon: '$stock', roles: [99, 1, 2, 101] } },
    { path: '/clients', name: 'Clientes', component: Clients, meta: { menu: 'main', group: 'Configuración', groupIcon: '$config', icon: '$client', roles: [99, 1, 2, 101] }},
    { path: '/clients/:id', name: 'Cliente', component: Client },
    { path: '/clients/:id/centers', name: 'ClientCenters', component: ClientCenters },
    { path: '/centers', name: 'Centros', component: Places, meta: { menu: 'main', icon: '$place', group: 'Configuración', roles: [99, 1, 101] } },
    { path: '/products', name: 'Productos', component: Products, meta: { menu: 'main', icon: '$product', group: 'Configuración', roles: [99, 1, 2, 101] } },
    { path: '/clusters', name: 'Clusters', component: Clusters, meta: { menu: 'main', icon: '$cluster', group: 'Configuración', roles: [99, 1, 2, 101] } },
    { path: '/clusters/:id', name: 'Cluster', component: Cluster },
    { path: '/issue-categories', name: 'Categorías de incidencia', component: IssueCategories, meta: { menu: 'main', icon: '$issue', group: 'Configuración', roles: [99, 1, 101] } },
    { path: '/channels', name: 'Canales', component: Channels, meta: { menu: 'main', icon: '$channel', group: 'Configuración', roles: [99, 1, 101] } },
    { path: '/brands', name: 'Marcas', component: Brands, meta: { menu: 'main', icon: '$brand', group: 'Configuración', roles: [99, 1, 101] } },
    { path: '/sectors', name: 'Sectores', component: Sectors, meta: { menu: 'main', icon: '$sector', group: 'Configuración', roles: [99, 1, 101] } },
    { path: '/user-logs', name: 'Log de usuarios', component: UserLogs, meta: { menu: 'main', icon: '$user', group: 'Configuración', roles: [99, 1, 101] } },
    { path: '/version-logs', name: 'Log de versiones', component: VersionLogs, meta: { menu: 'main', icon: 'mdi-view-list', group: 'Configuración', roles: [99, 1, 101] } },
    { path: '/integrations', name: 'Integraciones', component: Integrations, meta: { menu: 'main', icon: 'mdi-ray-start-end', group: 'Configuración', roles: [99, 1, 101] } },
    { path: '/holidays', name: 'Festivos', component: Holidays, meta: { menu: 'main', icon: 'mdi-calendar', group: 'Configuración', roles: [99, 1, 101] } },
    { path: '/info', name: 'Información', component: Info, meta: { menu: 'main', icon: 'mdi-information-outline', group: 'Configuración', roles: [99, 1, 101] } },
    { path: '/chat', name: 'Chats', component: Chat, meta: { menu: 'bottom', icon: '$chat', roles: [99, 1, 2, 101] } },
    { path: '/issues', name: 'Incidencias', component: Issues, meta: { menu: 'bottom', icon: '$issue', roles: [99, 1, 2, 3, 101], tag: RouteTag.ISSUES } },
    { path: '/tasks', name: 'Tareas', component: Tasks, meta: { menu: 'bottom', icon: '$task', roles: [99, 1, 2, 4, 101] } }
  ]
});

// Roles allowed on a route come from meta.roles, the same list that builds the menu. Detail
// routes (/users/:id, the campaign subpages) carry no meta.roles and are not gated here: what
// gates them is the listing they are reached from and, above all, the server, which checks the
// role on every request.
function isAllowed( route, user ) {
  const roles = route.meta && route.meta.roles;
  if ( ! roles ) return true;
  return !! user && roles.includes( user.role );
}

// First route this user may open, used as the landing page when they ask for one they cannot.
function firstAllowed( user ) {
  const route = router.options.routes.find( route => route.meta && route.meta.roles
    && user && route.meta.roles.includes( user.role ));
  return route ? route.path : null;
}

// App.vue loads the current user after the router has already mounted, so on a direct URL or a
// reload the first navigation happens before the role is known. Wait for it instead of deciding
// without it, which would bounce a superadmin out of their own page. Every branch of
// refreshToken leaves userID at either the real id or -1, and the timeout covers the rest.
function userResolved() {
  if ( store.state.userID !== -2 ) return Promise.resolve();

  return new Promise( resolve => {
    const finish = () => {
      clearTimeout( timer );
      unwatch();
      resolve();
    };
    const unwatch = store.watch( state => state.userID, id => id !== -2 && finish());
    const timer = setTimeout( finish, 15000 );
  });
}

// Where this navigation ends up: undefined lets it through, a path sends it elsewhere.
function destination( to ) {
  const user = store.state.user;

  if ( isAllowed( to, user )) return undefined;
  if ( ! user ) return '/login';

  store.dispatch( 'console/warn', 'No tiene permisos para acceder a esta página' );

  const fallback = firstAllowed( user );
  return fallback && fallback !== to.path ? fallback : '/login';
}

router.beforeEach((to, from, next) => { // eslint-disable-line no-unused-vars
  userResolved().then(() => {

    const target = destination( to );
    const prevent = store.state.app.preventRouting;

    if (!prevent) next(target);
    else {

      var cancel = typeof prevent.cancel === 'function' ? prevent.cancel : null;
      var accept = typeof prevent.accept === 'function' ? prevent.accept : null;

      store.commit('app/setDialog', {
        ...prevent,
        cancel: function (event) {
          cancel && cancel(event);
          next(false);
        },
        accept: function (event) {
          accept && accept(event);
          store.commit('app/preventRouting', false);
          next(target);
        },
      });
    }
  });
});


Axios.interceptors.response.use((response) => {
  return response
}, (error) => {
  if (error.response.status == 401) {
    console.log("send me to login");
    store.dispatch( 'logout' );
    router.push('/login');
  }
  else {
    return Promise.reject(error);
  }
})

export default router;
